import { React } from 'react';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

// All fields on this tab are derived from Sales Details, mirroring the legacy AllPrice()
// recalculation that ran on tab switch and again right before save. Only the aggregate
// (All In Price) is ever persisted — these are display-only breakdown fields.
const BuyerSummery = ({ tableLoading, salesDetails }) => {
    const { currencyPrecision } = useCurrency();
    const decimals = currencyPrecision?.decimalNumbers || 2;

    const num = (v) => Number(v) || 0;
    const fmt = (v) => num(v).toFixed(decimals);

    const sellerTransfer = num(salesDetails?.profit) + num(salesDetails?.sellerPaidDev);
    // "Amount due to Developer" is always the complement of "Seller has Paid to Developer".
    const developerBalance = num(salesDetails?.orignalPrice) - num(salesDetails?.sellerPaidDev);
    const developerBalancePerc = (100 - num(salesDetails?.sellerPaidDevCalcu)).toFixed(4);
    const buyerCommission = num(salesDetails?.commPaid);
    const buyerCommissionPerc = salesDetails?.commPaidCalculate;
    const dldTransfer = num(salesDetails?.buyerTransferFee);
    const dldTransferPerc = salesDetails?.buyerTransferFeeCalcu;
    const adminFee = num(salesDetails?.legalFee);
    const adminFeePerc = salesDetails?.legalFeeCalcu;
    const otherFee = num(salesDetails?.miscFee);
    const otherFeePerc = salesDetails?.miscFeeCalcu;
    const allInPrice = sellerTransfer + developerBalance + buyerCommission + dldTransfer + adminFee + otherFee;

    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <div className="form-group">
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Due to Seller on Transfer</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(sellerTransfer)} /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">Balance to Developer</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(developerBalance)} /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={developerBalancePerc || fmt(0)} /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1 start">Commission Paid By Buyer</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(buyerCommission)} /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={buyerCommissionPerc || fmt(0)} /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">Transfer Fee to DLD</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(dldTransfer)} /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={dldTransferPerc || fmt(0)} /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1 start">Administration Fee</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(adminFee)} /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={adminFeePerc || fmt(0)} /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1">Other Fee</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(otherFee)} /></div>
                        <div className=" col-1"><h8 className='center p-1'>%</h8></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={otherFeePerc || fmt(0)} /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">All in Price</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" disabled value={fmt(allInPrice)} /></div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default BuyerSummery
